import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './translations/en.json';
import esTranslations from './translations/es.json';
import frTranslations from './translations/fr.json';
import deTranslations from './translations/de.json';
import ptTranslations from './translations/pt.json';

function detectInitialLanguage() {
  try {
    // Check localStorage for preferred_locale (from livelovespain.com) or selectedLanguage
    const preferredLocale = typeof window !== 'undefined' ? localStorage.getItem('preferred_locale') : null;
    const selectedLanguage = typeof window !== 'undefined' ? localStorage.getItem('selectedLanguage') : null;
    
    // Check URL path for language prefix
    const path = typeof window !== 'undefined' ? window.location.pathname : '';
    const pathSegments = path.split('/').filter(Boolean);
    const urlLang = pathSegments[0];
    
    const supported = ['en', 'es', 'fr', 'de', 'pt'];
    
    // Priority: URL > preferred_locale > selectedLanguage > browser > default
    if (urlLang && supported.includes(urlLang)) return urlLang;
    if (preferredLocale && supported.includes(preferredLocale)) return preferredLocale;
    if (selectedLanguage && supported.includes(selectedLanguage)) return selectedLanguage;
    
    // Browser language detection
    const browser = typeof navigator !== 'undefined' ? navigator.language?.split('-')[0] : 'en';
    if (supported.includes(browser)) return browser;
  } catch (error) {
    console.error('Error detecting language:', error);
  }
  return 'en';
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      es: { translation: esTranslations },
      fr: { translation: frTranslations },
      de: { translation: deTranslations },
      pt: { translation: ptTranslations }
    },
    lng: detectInitialLanguage(),
    fallbackLng: 'en',
    interpolation: { 
      escapeValue: false 
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;











